/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonSolid/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonSolid({
  children,
  viewPath = "/DesignSystem/ButtonSolid",
  alignSelf = "auto",
  order = "unset",
  backgroundColor = "rgba(0,188,112, 1)",
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  id,
  isDisabled,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onClick,
  goTo,
  paddingBottom = 18,
  paddingLeft = 32,
  paddingRight = 32,
  paddingTop = 18,
  width = "auto",
  isDisabledX,
  isLoading,
  text = "Default Label"
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="ButtonSolid.Vertical"
  data-view-path={viewPath}
 id={id}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--as-1-Z7pK6D': alignSelf,'--o-2-Z7pK6D': order,'--bblr-4-Z7pK6D': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-5-Z7pK6D': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-6-Z7pK6D': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-7-Z7pK6D': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--ml-9-Z7pK6D': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z7pK6D': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z7pK6D': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pb-12-Z7pK6D': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-13-Z7pK6D': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-14-Z7pK6D': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-15-Z7pK6D': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-17-Z7pK6D': typeof width === 'number' ? `${width}px` : width,'--bc-3-Z7pK6D': isHovered ? "rgba(0,188,112, 0.7)" : isDisabledX ? "rgba(0,188,112, 0.25)" : isLoading ? "rgba(0,188,112, 0.35)" : backgroundColor,'--o-16-Z7pK6D': isBefore ? 0 : 1,'--c-8-Z7pK6D': isDisabledX ? "auto" : isLoading ? "auto" : "pointer",'--pe-18-Z7pK6D': isDisabledX ? "none" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="ButtonSolid.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</a>
{children}
</React.Fragment>)
}